import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {BingMapMarker} from "../../../bing-map-marker";
import {BingMapsLoaderService} from "../../../service/bing-maps-loader.service";
import {BingMapsMobileService} from "../../../service/bing-maps-mobile.service";
import {emit} from "cluster";

@Component({
  selector: 'app-bing-map-mobile',
  templateUrl: './bing-map-mobile.component.html',
  styleUrls: ['./bing-map-mobile.component.scss']
})
export class BingMapMobileComponent implements OnInit, OnChanges {

  @ViewChild("map") myMap;

  private map: Microsoft.Maps.Map;

  @Input() marker: BingMapMarker;

  @Output() mapReadyNotifier = new EventEmitter();

  mapReady = false;

  counter = 0;

  constructor(private bingServiceMobile: BingMapsMobileService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.mapReady) {
      this.bingServiceMobile.clearPushpins();
      this.bingServiceMobile.addPushpins([this.marker]);
    }
    if (this.counter++>200){
      debugger
    }
  }

  ngOnInit(): void {
    BingMapsLoaderService.load()
      .then(res => {
        this.map = this.bingServiceMobile.generateMap(this.myMap.nativeElement, undefined, [this.marker], true, true);
        this.mapReady = true;
      });
    let temp = this;
    setTimeout(function () {
      temp.mapReadyNotifier.emit();
    },5000);
  }

}
